module.exports = __webpack_public_path__ + "img/amount-deco.6b13a307.png";